import React from 'react'
import LinkWrap from './LinkWrap';
import PicCont from './PicCont';
import { AiOutlinePhone } from '@react-icons/all-files/ai/AiOutlinePhone';
import audio from '../public/Pictures/audio-equipment.png'
import cdj from '../public/Pictures/cdj.png'
import lighting from '../public/Pictures/stage-lighting.png'
import visuals from '../public/Pictures/visuals.png'
import coldspark from '../public/Pictures/cold-spark-machine.png'
import projector from '../public/Pictures/projector.png'
import { useSelector } from 'react-redux';
import { getUserUTM } from '../store/slices/user';
import { useRouter } from 'next/dist/client/router';
import * as gtag from '../lib/gtag'

const CatBar = ({}) => {
    let utm = useSelector(getUserUTM)
    let { push, query, asPath } = useRouter()
  return    <div data-msr-surface='dark' className="pagesRow">
  <LinkWrap noPrefetch href={'/sound-system-rental'} className={`col ${asPath.includes('sound') ? 'active':'faded'}`}>
  <span >Sound Systems</span>
      <PicCont src={audio} width={50} height={50} alt='Sound Package' />
  </LinkWrap>
  <LinkWrap noPrefetch href={'/dj-equipment-rental'} className={`col ${asPath.includes('dj-equipment') ? 'active':'faded'}`}>
  <span  >DJ Equipment</span>
      <PicCont src={cdj} width={50} height={50} alt='Pioneer CDJ 2000 NXS' />
  </LinkWrap>
  <LinkWrap noPrefetch href={'/lighting-rental'} className={`col ${asPath.includes('lighting') ? 'active':'faded'}`}>
  <span  >Lighting</span>
      <PicCont src={lighting} width={50} height={50} alt='Moving Head' />
  </LinkWrap>
  <a className="assCall NOPHONE" href="tel:+13059744411" onClick={() => gtag.event({ action: 'booking_assistance_call', label: 'leads', value: 20, category: 'orders' })}>
            <AiOutlinePhone />305 974 4411
  </a>
  <LinkWrap noPrefetch className={`col right ${asPath.includes('staging') ? 'active':'faded'}`} href={'/stage-rental'}>
  <span >Staging</span>
      <PicCont src={visuals} width={50} height={50} alt='LED Video Wall' />
  </LinkWrap>
  <LinkWrap  noPrefetch href={'/visuals'} className={`col right ${asPath.includes('visuals') ? 'active':'faded'}`}>
  <span  >Visuals</span>
      <PicCont src={projector} width={50} height={50} alt='Projector' />
  </LinkWrap>
  <LinkWrap noPrefetch href={'/special-effects'} className={`col right ${asPath.includes('special-effects') ? 'active':'faded'}`}>
  <span  >Special Effects</span>
      <PicCont src={coldspark} width={50} height={50} alt='Cold Spark Machine' />
  </LinkWrap>
</div>
}

export default CatBar
